const LESSON_SETTINGS_TYPES = {
  FETCH_PILLAR_METADATA_WITH_SCHEDULE_BEGIN:
    "FETCH_PILLAR_METADATA_WITH_SCHEDULE_BEGIN",
  FETCH_PILLAR_METADATA_WITH_SCHEDULE_SUCCESS:
    "FETCH_PILLAR_METADATA_WITH_SCHEDULE_SUCCESS",
  FETCH_PILLAR_METADATA_WITH_SCHEDULE_FAILURE:
    "FETCH_PILLAR_METADATA_WITH_SCHEDULE_FAILURE",

  UPDATE_PILLAR_METADATA_BEGIN: "UPDATE_PILLAR_METADATA_BEGIN",
  UPDATE_PILLAR_METADATA_SUCCESS: "UPDATE_PILLAR_METADATA_SUCCESS",
  UPDATE_PILLAR_METADATA_FAILURE: "UPDATE_PILLAR_METADATA_FAILURE",
};

export default LESSON_SETTINGS_TYPES;
